import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin-without-reset-scss'
import SearchBar from 'www/vue_components/common/SearchBar/SearchBar.vue'
import 'www/vue_components/common/SearchBar/index.scss'

const el = document.querySelector('.vue-search-bar-mount')

if (el) {
  new Vue({
    vuetify,
    el,
    components: {
      SearchBar,
    },
  })
}
